import Vue from "vue";
import Vuex, {ActionTree, GetterTree, MutationTree, StoreOptions} from "vuex";
import {auth} from "@/store/modules/auth";
import {header} from "@/store/modules/header";
import {timeclock} from "@/store/modules/timeclock";
import {RootState} from "@/store/types";
import DefaultService from "@/service/DefaultService";
import moment from "moment";
import {registration} from "@/store/modules/registration";

Vue.use(Vuex);

export const GeneralGetters = Object.freeze({
  GET_EARLIEST_VALID_FROM: "getEarliestValidFrom"
});

const getters: GetterTree<RootState, RootState> = {
  [GeneralGetters.GET_EARLIEST_VALID_FROM]: (state) => {
    return state.general.earliestValidFrom;
  }
};

export const Mutations = Object.freeze({
  SET_EARLIEST_VALID_FROM: "setEarliestValidFrom"
});

const mutations: MutationTree<RootState> = {
  [Mutations.SET_EARLIEST_VALID_FROM] (state, earliestValidFrom: string) {
    state.general.earliestValidFrom = earliestValidFrom;
  }
};

export const Actions = Object.freeze({
  GET_EARLIEST_VALID_FROM: "getEarliestValidFrom"
});

const actions: ActionTree<RootState, RootState> = {
  [Actions.GET_EARLIEST_VALID_FROM] ({ commit }) {
    DefaultService.getDefaults()
      .then(response => {
        commit(Mutations.SET_EARLIEST_VALID_FROM, response.data.earliestValidFrom);
      });
  }
};

const store: StoreOptions<RootState> = {
  modules: {
    auth,
    header,
    registration,
    timeclock
  },
  state: {
    general: {
      earliestValidFrom: moment().format("YYYY-MM-01")
    }
  },
  actions,
  mutations,
  getters
};

const vuexStore = new Vuex.Store<RootState>(store);

export default vuexStore;
